var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVehicleCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11499_2412)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11499_2412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4757 15.5031C36.3126 15.3042 36.0694 15.1881 35.8142 15.1881H32.57C31.7694 13.0765 30.7264 11.0076 29.5408 10.2266C25.4397 7.52863 14.5616 7.52863 10.4604 10.2266C9.27401 11.0084 8.23528 13.0799 7.43041 15.1881H4.18619C3.92842 15.1881 3.68602 15.3042 3.52471 15.5031C3.36254 15.7011 3.29767 15.9631 3.35059 16.2149L3.83112 18.5433C3.91306 18.9402 4.263 19.2235 4.66672 19.2235H5.62778C4.7 20.2939 4.2502 21.6416 4.24422 22.9901C4.23825 24.6562 4.87071 26.1618 6.02723 27.227C6.04003 27.2381 6.05283 27.2458 6.06478 27.2569V30.5148C6.06478 31.2206 6.63835 31.795 7.34506 31.795H10.3375C11.0442 31.795 11.6178 31.2206 11.6178 30.5148V29.2055H28.3817V30.5148C28.3817 31.2206 28.9553 31.795 29.662 31.795H32.6545C33.3595 31.795 33.9347 31.2206 33.9347 30.5148V27.3209C35.1621 26.1968 35.7485 24.6502 35.7561 23.1062C35.7613 21.7116 35.291 20.3143 34.3086 19.2218H35.3337C35.7391 19.2218 36.089 18.9385 36.1693 18.5407L36.6506 16.2132C36.7001 15.9631 36.6378 15.7028 36.4757 15.5031ZM11.8661 12.3647C15.1351 10.2129 24.8644 10.2129 28.1317 12.3647C28.7667 12.7812 29.5835 14.4652 30.332 16.5273H9.66748C10.4143 14.466 11.2311 12.7829 11.8661 12.3647ZM8.03726 23.3111C8.03726 21.9198 9.16562 20.7932 10.556 20.7932C11.9481 20.7932 13.0747 21.9198 13.0747 23.3111C13.0747 24.7023 11.9481 25.8298 10.556 25.8298C9.16562 25.8298 8.03726 24.7023 8.03726 23.3111ZM29.4768 25.8298C28.0864 25.8298 26.9581 24.7023 26.9581 23.3111C26.9581 21.9198 28.0864 20.7932 29.4768 20.7932C30.8689 20.7932 31.9955 21.9198 31.9955 23.3111C31.9955 24.7023 30.8672 25.8298 29.4768 25.8298Z",
    fill: "#B18535"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11499_2412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11499_2412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3342,
    height: 33.3333,
    fill: "white",
    transform: "translate(3.33301 3.33301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicleCar);
export default __webpack_public_path__ + "static/media/icon_vehicle_car.bc900cd4ed61ec77bd725a0f88cb9174.svg";
export { ForwardRef as ReactComponent };